module.exports = __webpack_public_path__ + "img/fopeaInsultosX2.dfdf2a54.jpg";